import { render, staticRenderFns } from "./HHAcceptTerm.vue?vue&type=template&id=377ec639&"
import script from "./HHAcceptTerm.vue?vue&type=script&lang=js&"
export * from "./HHAcceptTerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports